module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.06bd8a94.webp";